import clsx from "clsx";

export default function ButtonLayout(
    {
        className,
        children,
        icon = null
    }
) {
    return (
        <div className={clsx(
            "w-full h-full font-bold text-large px-[1.125rem] py-[0.625rem] hover:[&>div]:opacity-70",
            className
        )}>
            <div className="flex items-center gap-[0.3125rem] transition-all justify-center">
                <span className="whitespace-nowrap">
                    {children}
                </span>
                {icon && <div className="w-[1.25rem] aspect-square mobile:w-[1.75rem]">
                    {icon}
                </div>}
            </div>
        </div>
    )
}